<template>
    <div class="d-flex flex-wrap ga-5 w-100">
        <v-text-field
            v-model.number="localContractValue"
            label="Valoare contract"
            type="number"
            min="0"
            variant="outlined"
            density="compact"
            :max-width="$vuetify.display.smAndDown ? '100%' : '200px'"
            :readonly="!canEdit"
            :disabled="contractAccess && contractAccess.is_signed"
            :error-messages="
                !localContractValue
                    ? 'Valoarea contractului este obligatorie'
                    : ''
            "
            @input="validateContractValue"
            hide-details="auto"
        />

        <v-textarea
            :max-width="$vuetify.display.smAndDown ? '100%' : '35%'"
            v-model="localObservations"
            label="Observații"
            variant="outlined"
            rows="1"
            auto-grow
            density="compact"
            hide-details
            @blur="$emit('update:observations', localObservations)"
        />

        <v-btn
            v-if="localContractValue !== originalContractValue"
            :disabled="!localContractValue"
            color="success"
            @click="$emit('save-contract-value')"
            >Salvează valoarea contractului</v-btn
        >

        <v-btn :disabled="!canView" @click="$emit('generate-contract')"
            >Vizualizează contract</v-btn
        >

        <v-btn
            :disabled="!canSend"
            :loading="isLoading"
            @click="$emit('trigger-send-email')"
            >Trimite contractul</v-btn
        >

        <v-btn
            v-if="canGenerateAdditional"
            color="primary"
            variant="elevated"
            @click="$emit('add-new-act')"
        >
            Adaugă Act Adițional
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "ContractFields",
    props: {
        signatureInfo: {
            type: String,
            default: "",
        },
        contractValue: Number,
        originalContractValue: Number,
        observations: String,
        contractAccess: Object,
        client: Object,
        isLoading: Boolean,
        isSendingActEmail: Boolean,
    },
    data() {
        return {
            localContractValue: this.contractValue,
            localObservations: this.observations,
        };
    },
    watch: {
        localContractValue(val) {
            this.$emit("update:contractValue", val);
        },
    },
    computed: {
        canEdit() {
            return this.$store.getters.userPermissions.greenHouseSolarManagement
                .canEditClient;
        },
        canView() {
            return (
                this.localContractValue === this.originalContractValue &&
                this.client.offer_kw &&
                this.client.offer_storage_kw
            );
        },
        canSend() {
            const status = this.client.contract_status;
            const signature = this.signatureInfo;
            const access = this.contractAccess;
            return (
                this.canEdit &&
                this.canView &&
                (signature === "Contract Nesemnat" ||
                    !(
                        access?.is_sent ||
                        access?.is_signed ||
                        status === "Trimis"
                    ))
            );
        },
        canGenerateAdditional() {
            const status = this.client.contract_status;
            const signature = this.signatureInfo;
            const access = this.contractAccess;
            return (
                !this.$store.getters.userPermissions ||
                (signature !== "Contract Nesemnat" &&
                    (access?.is_sent ||
                        access?.is_signed ||
                        status === "Trimis"))
            );
        },
    },
    methods: {
        /**
         * Validates the entered contract value.
         */
        validateContractValue() {
            if (this.localContractValue < 0) {
                this.localContractValue = 0;
            } else if (
                !this.localContractValue ||
                isNaN(this.localContractValue)
            ) {
                this.localContractValue = null;
                this.$store.dispatch("showAlert", {
                    type: "warning",
                    message:
                        "Valoarea contractului trebuie să fie un număr valid!",
                });
            }
        },
    },
};
</script>
